/**
 * metersFilter
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

export function metersFilter() {
    return value => {
        if (value !== null && value !== undefined) {
            return `${value} metres`;
        }
    };
}
